export default {
  name:'toast',
  data(){
    return {
      message:'',
      position:'middle',
      duration:1000,
      isShow:true,
    }
  },
  mounted() {
    setTimeout(()=>{
      this.isShow=false
    },this.duration)
  },

}